import * as _generic from './translations/generic';
import * as _cart from './translations/cart';
import * as _product from './translations/product';
import * as _payment from './translations/payment';
import * as _user from './translations/user';
import * as _userProfile from './translations/userProfile';
import * as _userAccount from './translations/userAccount';
import * as _myAccount from './translations/myAccount';
import * as _order from './translations/order';
import * as _savedCart from './translations/savedCart';
import * as _importExport from './translations/importExport';
import * as _checkoutB2B from './translations/checkoutB2B';
import * as _checkout from './translations/checkout';
import * as _address from './translations/address';
import * as _organization from './translations/organization';
import * as _toggleText from './translations/toggleText';
import * as _selectCountries from './translations/selectCountries';
import * as _styleGuide from './translations/styleGuide';
import * as _contentPages from './translations/contentPages';
import * as _quotes from './translations/quotes';
import * as _reports from './translations/reports';
import * as _invoices from './translations/invoice';
import * as _returns from './translations/return';
import * as _storeFinder from './translations/storeFinder';
import * as _approvalspage from './translations/approvalspage';
import * as _dragAndDrop from './translations/dragAndDrop';
import * as _amorphSelect from './translations/amorphSelect';
import * as _tablePro from './translations/tablePro';
import * as _shipments from './translations/shipment';
import * as _quickOrder from './translations/quickOrder';
import * as _facets from './translations/facets';
import * as _advancedSearch from './translations/advancedSearch';

export const translation = _generic.translation;
export const common = _generic.common;
export const cart = _cart.cart;
export const product = _product.product;
export const payment = _payment.payment;
export const user = _user.user;
export const userProfile = _userProfile.userProfile;
export const userAccount = _userAccount.userAccount;
export const myAccount = _myAccount.myAccount;
export const order = _order.order;
export const savedCart = _savedCart.savedCart;
export const importExport = _importExport.importExport;
export const checkoutB2B = _checkoutB2B.checkoutB2B;
export const checkout = _checkout.checkout;
export const address = _address.address;
export const toggleText = _toggleText.toggleText;
export const organization = _organization.organization;
export const selectCountries = _selectCountries.selectCountries;
export const styleGuide = _styleGuide.styleGuide;
export const contentPages = _contentPages.contentPages;
export const quotes = _quotes.quotes;
export const reports = _reports.reports;
export const invoices = _invoices.invoice;
export const returns = _returns.r;
export const storeFinder = _storeFinder.storeFinder;
export const shipments = _shipments.shipment;
export const approvalspage = _approvalspage.approvalspage;
export const dragAndDrop = _dragAndDrop.dragAndDrop;
export const amorphSelect = _amorphSelect.amorphSelect;
export const tablePro = _tablePro.tablePro;
export const quickOrders = _quickOrder.ndbsQuickOrder;
export const facets = _facets.customFacets;
export const advancedSearch = _advancedSearch.advancedSearch;
export const clearCart = _cart.clearCart;
export const cartItems = _cart.cartItems;
